<template>
    <b-container>
        <b-row class="justify-content-center">
            <b-col cols="12" class="text-left">
                <p>Gentile Societ&agrave;,<br /><br /><strong>benvenuta sul nuovo portale</strong> che FC Internazionale Milano ha pensato di dedicare alle <strong>societ&agrave; sportive</strong>.<br /><br />Registrati un'unica volta per restare aggiornata sulle iniziative e creare la tua rubrica di atleti e accompagnatori abituali, per cui potrai richiedere i biglietti, valida e modificabile per tutta la stagione sportiva.<br /><br />Per poter ultimare la registrazione &egrave; necessario inserire i dati societari, la visura camerale e indicare un referente obbligatorio; il profilo verr&agrave; verificato e abilitato all'accesso nei giorni successivi dal nostro Staff.<br /><br />Se hai gi&agrave; a disposizione tutte queste informazioni clicca sul bottone '<strong>PROCEDI</strong>' per continuare.<br /><br /><small><i>Per qualsiasi informazione scrivere a <a href="mailto:bigliettiscuolecalcio@inter.it" target="_blank"> bigliettiscuolecalcio@inter.it</a> oppure contatta il nostro servizio clienti al numero 02.82942000 (luned&igrave;-venerd&igrave;, 09:00-13:00/14:00-18:00).</i></small></p>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    export default {
        name: "RegisterWizardStepOne"
    }
</script>

<style scoped>

</style>
